import React, { FC } from 'react';
import { BasketSelectSectionProps } from '@components/v2/BasketSelectSection';

const BasketSelectSectionTemplate: FC<BasketSelectSectionProps> = ({
    onClick,
    leftValue,
    rightValue,
    rightDetail,
    className,
    leftSelected,
    rightSelected,
    leftSectionTitle,
    leftSectionDescription,
    rightSectionTitle,
    rightSectionDescription,
}) => {
    return (
        <div className={className}>
            <div className="sections">
                {leftValue && (
                    <button
                        className={`left ${leftSelected ? 'selected' : ''}`}
                        onClick={() => onClick(leftValue)}
                        data-testid={`TESTING_SELECTION_${leftValue?.toUpperCase()}`}
                    >
                        <div className="inner">
                            <span className="title">
                                <span className={`icon ${leftSelected ? 'selected' : ''}`}>
                                    <span className={leftSelected ? 'selected' : ''} />
                                </span>{' '}
                                {leftSectionTitle}
                            </span>
                            <span className="description">{leftSectionDescription}</span>
                        </div>
                    </button>
                )}
                {rightValue && (
                    <button
                        className={`right ${rightSelected ? 'selected' : ''}`}
                        onClick={() => onClick(rightValue)}
                        data-testid={`TESTING_SELECTION_${rightValue?.toUpperCase()}`}
                    >
                        <div className="inner">
                            <span className="title">
                                <span className={`icon ${rightSelected ? 'selected' : ''}`}>
                                    <span className={rightSelected ? 'selected' : ''} />
                                </span>{' '}
                                {rightSectionTitle}
                            </span>
                            <span className="description">{rightSectionDescription}</span>
                            {rightDetail?.title && (
                                <div className="detail">
                                    <img src={rightDetail.image} alt={rightDetail.title} />
                                    <div className="detail_rows">
                                        <div className="label">{rightDetail.label}</div>
                                        <div className="title">{rightDetail.title}</div>
                                        <div className="shortDescription">{rightDetail.description}</div>
                                        <div className="price">{rightDetail.price}</div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </button>
                )}
            </div>
        </div>
    );
};

export default BasketSelectSectionTemplate;
